/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPlumbingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-plumbing"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M19.27 8.28L15.75 4.75L13.63 6.85L11.05 4.3L14.1 1.23Q14.45 0.88 14.86 0.71Q15.28 0.55 15.72 0.55Q16.18 0.55 16.6 0.71Q17.02 0.88 17.38 1.23L19.5 3.35Q20 3.85 20.24 4.44Q20.48 5.03 20.48 5.63Q20.48 6.38 20.14 7.06Q19.8 7.75 19.27 8.28ZM4.42 13.5Q3.88 12.95 3.88 12.21Q3.88 11.47 4.42 10.93L6.6 8.72L9.18 11.3L6.97 13.5Q6.45 14.07 5.71 14.06Q4.97 14.05 4.42 13.5ZM4.2 21.43Q3.85 21.07 3.69 20.65Q3.52 20.23 3.52 19.77Q3.52 19.32 3.69 18.9Q3.85 18.48 4.2 18.13L11.05 11.3L7.35 7.58Q6.78 7.03 6.8 6.3Q6.83 5.58 7.35 5.03Q7.9 4.47 8.64 4.47Q9.38 4.47 9.93 5.03L13.63 8.72L15.05 7.3L18.07 10.38Q18.48 10.78 18.48 11.3Q18.48 11.82 18.07 12.22Q17.75 12.55 17.31 12.61Q16.88 12.68 16.48 12.43L7.47 21.43Q7.13 21.77 6.71 21.94Q6.3 22.1 5.85 22.1Q5.4 22.1 4.97 21.94Q4.55 21.77 4.2 21.43Z" fill={color} />
    </svg>
  );
}
